// flow/components/FlowDialogs.tsx
import FileResourcingDialog from '@/components/dialogs/FileResourcingDialog'
import NodeIndexDialog from '@/components/dialogs/node-index-dialog'
import NodeBlueprintsAndWorkflowsDialog from '@/components/dialogs/blueprints-and-workflows-dialog/NodeBlueprintsAndWorkflowsDialog'
import ProjectSettings from '@/components/dashboard/ProjectSettings'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { Node } from '@xyflow/react'

interface FlowDialogsProps {
  // File dialog
  showFileDialog: boolean
  setShowFileDialog: (show: boolean) => void
  userId: string
  
  // Node index dialog
  showNodeIndex: boolean
  setShowNodeIndex: (show: boolean) => void
  nodes: Node[]
  onNodeSelect: (nodeId: string) => void
  
  // Blueprints dialog
  showBlueprints: boolean
  setShowBlueprints: (show: boolean) => void
  
  // Project settings dialog
  showProjectSettings: boolean
  setShowProjectSettings: (show: boolean) => void
  projectId: string
  projectName: string
  projectDescription: string
  projectType?: string
  organizationName?: string
  projectSettings: any
  projectSettingsAccessRules: any[]
  fetchProjectSettings: () => void
}

export function FlowDialogs({
  showFileDialog,
  setShowFileDialog,
  userId,
  showNodeIndex,
  setShowNodeIndex,
  nodes,
  onNodeSelect,
  showBlueprints,
  setShowBlueprints,
  showProjectSettings,
  setShowProjectSettings,
  projectId,
  projectName,
  projectDescription,
  projectType,
  organizationName,
  projectSettings,
  projectSettingsAccessRules,
  fetchProjectSettings,
}: FlowDialogsProps) {
  return (
    <>
      <FileResourcingDialog
        visible={showFileDialog}
        onHide={() => setShowFileDialog(false)}
        userId={userId}
      />

      <NodeIndexDialog
        visible={showNodeIndex}
        onHide={() => setShowNodeIndex(false)}
        nodes={nodes}
        onNodeSelect={onNodeSelect}
      />

      <NodeBlueprintsAndWorkflowsDialog
        open={showBlueprints}
        onOpenChange={setShowBlueprints}
      />

      {/* Project Settings Dialog */}
      <Dialog
        open={showProjectSettings}
        onOpenChange={setShowProjectSettings}
      >
        <DialogContent className="sm:max-w-[700px]">
          <DialogHeader>
            <DialogTitle>Project Settings</DialogTitle>
          </DialogHeader>          
          {projectSettings && typeof projectSettings === 'object' ? (            
            <ProjectSettings
              projectId={projectId}
              projectName={projectName}
              projectDescription={projectDescription}
              projectType={projectType}
              organizationName={organizationName}
              settings={projectSettings}
              accessRules={projectSettingsAccessRules}
              closeModal={() => setShowProjectSettings(false)}
              onAccessRulesUpdate={fetchProjectSettings}
              systemAgentEnabled={
                typeof projectSettings.systemAgentEnabled !== 'undefined'
                  ? projectSettings.systemAgentEnabled
                  : null
              }
              onSystemAgentEnabledChange={fetchProjectSettings}
            />
          ) : (
            <div className="p-4 text-center text-gray-500">
              Loading project details...
            </div>
          )}
        </DialogContent>      </Dialog>
    </>
  )
}

export default FlowDialogs
